import type { AdminContactListParams, AdminContactListResult } from "@/interfaces/adminContacts";
import { apiClient } from "@/lib/apiClient";

/**
 * GET /admin/contacts -- the screen's ONE endpoint: paginated, searchable, filterable, sortable
 * cross-org contact rows, plus the four filter dropdown lists when `includeFilterOptions` is set.
 */
export async function fetchAdminContacts(
  params?: AdminContactListParams,
): Promise<AdminContactListResult> {
  const query: Record<string, string | number> = {};
  if (params?.search) query.search = params.search;
  if (params?.organization_id?.length) query.organization_id = params.organization_id.join(",");
  if (params?.status?.length) query.status = params.status.join(",");
  if (params?.account_lead_id?.length) query.account_lead_id = params.account_lead_id.join(",");
  if (params?.campaign_id?.length) query.campaign_id = params.campaign_id.join(",");
  if (params?.sortBy) query.sortBy = params.sortBy;
  if (params?.sortDir) query.sortDir = params.sortDir;
  if (params?.page && params.page > 1) query.page = params.page;
  if (params?.limit) query.limit = params.limit;
  if (params?.includeFilterOptions) query.includeFilterOptions = "true";

  const { data } = await apiClient.get<AdminContactListResult>("/admin/contacts", {
    params: query,
  });
  return data;
}
